import Service from "../AuthService";
const Machine = {
    getMachine() {
        return Service.get("/machine_all");
    },
    getMachineSheet(){
        return Service.get('/machine_sheet_all');
    }
};
export default Machine;
